import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';

const PickProductsForm = () => {
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState('');
  const [merchantId, setMerchantId] = useState('');
  const [productName, setProductName] = useState('');
  const [discountPercentage, setDiscountPercentage] = useState('');
  const [price, setPrice] = useState('');
  const [date, setDate] = useState('');
  const [rejectionReason, setRejectionReason] = useState('0');

  const [startDateTime, setStartDateTime] = useState('');
  const [endDateTime, setEndDateTime] = useState('');
  const [discountAmount, setDiscountAmount] = useState('');

  const fileInputRef = useRef(null);

  // ✅ Set today's date once
  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setDate(today);
  }, []);

  // ✅ Set URL when merchantId changes
  useEffect(() => {
    if (merchantId) {
      setUrl(`bakpoket.com/merchantproductsite/${merchantId}`);
    }
  }, [merchantId]);

  // ✅ Auto calculate discount amount
  useEffect(() => {
    if (price && discountPercentage) {
      const discount = (price * discountPercentage) / 100;
      setDiscountAmount(discount.toFixed(2));
    }
  }, [price, discountPercentage]);

  const PickProductsUpload = async (e) => {
    e.preventDefault();

    if (
      !image ||
      !productName ||
      !price ||
      !merchantId ||
      !url ||
      !discountPercentage ||
      !startDateTime ||
      !endDateTime
    ) {
      alert('Please fill all fields before submitting');
      return;
    }

    const formData = new FormData();
    formData.append('ProductName', productName);
    formData.append('Price', Number(price));
    formData.append('MerchantURL', url);
    formData.append('MerchantID', Number(merchantId));
    formData.append('ProductImage', image);
    formData.append('UploadedDate', date);
    formData.append('RejectionReason', rejectionReason);
    formData.append('AdvisedChanges', rejectionReason);
    formData.append('DiscountPercentage', Number(discountPercentage));
    formData.append('DiscountAmount', Number(discountAmount));
    formData.append('StartDateTime', startDateTime);
    formData.append('EndDateTime', endDateTime);

    try {
      const res = await axios.post(
        'https://api.bakpoket.com/api/MerchantDetails/upload-MerchantProduct',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );

      if (res.data?.message?.includes('Data is Null')) {
        alert('Upload failed: ' + res.data.message);
        return;
      }

      alert('Product uploaded successfully!');

      // ✅ Reset form
      setProductName('');
      setPrice('');
      setDiscountPercentage('');
      setDiscountAmount('');
      setStartDateTime('');
      setEndDateTime('');
      setImage(null);

      if (fileInputRef.current) fileInputRef.current.value = null;

    } catch (err) {
      console.error('Upload error:', err);
      alert('Upload failed.');
    }
  };

  // ✅ Get merchantId from localStorage
  useEffect(() => {
    const googleLogin = localStorage.getItem('googleLogin');

    let merchantData = null;

    if (googleLogin === "false") {
      merchantData = localStorage.getItem('merchantLogin');
    } else {
      merchantData = localStorage.getItem('merchantDashboardLogin');
    }

    if (merchantData) {
      const parsedData = JSON.parse(merchantData);
      const id = parsedData.merchantId || parsedData.id;
      if (id) setMerchantId(id);
    }
  }, []);

  return (
    <Wrapper>
      <Card>
        <h2 className='text-center'>Upload Pick Your Product</h2>

        <form onSubmit={PickProductsUpload}>
          <input
            type="text"
            placeholder="Enter Product Name"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
          />

          <input
            type="number"
            placeholder="Enter Product Price"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />

          <input
            type="number"
            placeholder="Enter Discount Percentage"
            value={discountPercentage}
            onChange={(e) => setDiscountPercentage(e.target.value)}
          />

          {/* ✅ Auto calculated (readonly) */}
          <input
            type="number"
            placeholder="Discount Amount"
            value={discountAmount}
            readOnly
          />

          <input
            type="datetime-local"
            value={startDateTime}
            onChange={(e) => setStartDateTime(e.target.value)}
          />

          <input
            type="datetime-local"
            value={endDateTime}
            onChange={(e) => setEndDateTime(e.target.value)}
          />

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={(e) => setImage(e.target.files[0])}
          />

          <button type="submit">Submit</button>
        </form>
      </Card>
    </Wrapper>
  );
};

export default PickProductsForm;

const Wrapper = styled.section`
  display:flex;
  align-items:center;
  justify-content:center;
  height:50vh;
`;

const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: auto;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 15px;

    input {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }
`;